import { Constants } from "appConstants";
import { Button, SearchBar } from "components";
import { useNavigate } from "react-router-dom";
import "./styles.scss";

interface HeadingListingProps {
	title: string;
	setSearchValue: (value: string) => void;
	showSearchBar?: boolean;
	showAddButton?: boolean;
}

export default function HeadingListing(props: Readonly<HeadingListingProps>) {
	const {
		title,
		setSearchValue,
		showSearchBar = true,
		showAddButton = true
	} = props;
	const navigate = useNavigate();

	return (
		<div className="heading">
			<span className="font-heading-semibold-tiny">{title}</span>
			<div className="heading-controls">
				{showSearchBar && (
					<SearchBar
						label=""
						placeholder={Constants.strings.inputs.search}
						onSearch={(value: string) => setSearchValue(value)}
					/>
				)}
				{showSearchBar && showAddButton && <div className="divider" />}
				{showAddButton && (
					<Button size="medium" onClick={() => navigate("create")}>
						{Constants.strings.pages.newTenant.newProduct}
					</Button>
				)}
			</div>
		</div>
	);
}
